const ANALYTICS_ID = 'G-WBG2BT66CG';

let analyticsInstancePromise;

function hasWindow() {
    return typeof window !== 'undefined';
}

export function hasAnalyticsConsent() {
    if (!hasWindow()) {
        return false;
    }

    return localStorage.getItem('camdiab-cookie-flag') === 'true'
        && localStorage.getItem('camdiab-cookie-denied') !== 'true';
}

export async function initializeAnalytics() {
    if (!hasWindow() || !hasAnalyticsConsent()) {
        return null;
    }

    if (!analyticsInstancePromise) {
        analyticsInstancePromise = (async () => {
            const ReactGA = (await import('react-ga4')).default;

            ReactGA.initialize([
                {
                    trackingId: ANALYTICS_ID,
                    gtagOptions: {
                        send_page_view: false,
                    },
                },
            ]);

            return ReactGA;
        })();
    }

    return analyticsInstancePromise;
}

export function queueAnalyticsInit() {
    if (!hasWindow() || !hasAnalyticsConsent()) {
        return;
    }

    const schedule = window.requestIdleCallback
        ? window.requestIdleCallback.bind(window)
        : (callback) => window.setTimeout(callback, 1);

    schedule(() => {
        initializeAnalytics().catch(() => {
        });
    });
}

export async function trackPageView(page) {
    if (!hasWindow() || !hasAnalyticsConsent()) {
        return;
    }

    const ReactGA = await initializeAnalytics();
    if (!ReactGA) {
        return;
    }

    ReactGA.send({
        hitType: 'pageview',
        page,
        title: page,
    });
}
